
import { authorizeMe, axiosInstance } from './commonHeadApiLogic.js';

// Ensure authorization header is set before making authenticated requests
const withAuthorization = async (apiFunction, ...args) => {
  try {
    await authorizeMe(); // Ensure the Authorization header is set
    return await apiFunction(...args);
  } catch (error) {
    // Handle errors as necessary
    console.error("Error in API request:", error);
    throw error;
  }
};

export const getGalleryPlanAPI  = (page = 1, limit = 10) => {
  return withAuthorization(() =>
    axiosInstance.get( `/api/admins/cloud-plans?page=${page}&limit=${limit}`)
  );
};

// /api/admins/cloud-plans POST
export const createGalleryPlanAPI = (payload) => {
  return withAuthorization(() =>
    axiosInstance.post(`/api/admins/cloud-plans`, payload)
  );
};

export const updateGalleryPlanAPI = (id, payload) => {
  return withAuthorization(() =>
    axiosInstance.put(`/api/admins/cloud-plans/${id}`, payload)
  );
};


export const deleteGalleryPlanAPI = (id, payload) => {
  return withAuthorization(() =>
    axiosInstance.delete(`/api/admins/cloud-plans/${id}`)
  );
};
